import {
  PartialQuestionnaire,
  QuestionnaireConfiguration,
  QuestionnaireQuestions,
  Rule,
} from '../../models';
import { findPath } from '../findPath';

export const getNextQuestionId = <
  Questionnaire extends QuestionnaireQuestions,
  GroupId,
  ExtendedComponentTypes
>(
  currentQuestionId: keyof Questionnaire,
  questions: PartialQuestionnaire<
    Questionnaire,
    GroupId,
    ExtendedComponentTypes
  >,
  answers: Partial<Questionnaire>,
  rules: Rule<Questionnaire>[] = [],
  inclusive: boolean = false,
  configuration: QuestionnaireConfiguration<
    Questionnaire,
    ExtendedComponentTypes
  > = {}
): keyof Questionnaire => {
  const currentQuestionObject = questions.find(
    ({ id }) => id === currentQuestionId
  );

  if (!currentQuestionObject) {
    return questions?.[0].id;
  }

  const paths = findPath(questions, answers, rules, configuration);

  const currentIdx = questions.indexOf(currentQuestionObject);

  const lastUnansweredQuestion = questions.find(({ id, type }, idx) => {
    if (!paths.includes(id)) {
      return false;
    }
    const isCurrentPageAhead = currentIdx > idx;

    return (
      isCurrentPageAhead && type !== 'BLOCKER' && answers?.[id] === undefined
    );
  });
  if (lastUnansweredQuestion?.id) {
    return lastUnansweredQuestion?.id;
  }

  const currentQuestionAnswered = answers[currentQuestionId] !== undefined;

  if (inclusive || !currentQuestionAnswered) {
    return currentQuestionId;
  }

  const nextQuestion = questions.find(({ id }, idx) => {
    if (!paths.includes(id)) {
      return false;
    }
    return currentIdx < idx;
  });

  return nextQuestion ? nextQuestion.id : questions?.[0].id;
};
